import { render, staticRenderFns } from "./ContractProfileTemplateTab.vue?vue&type=template&id=510f8b9a&scoped=true&"
import script from "./ContractProfileTemplateTab.vue?vue&type=script&lang=js&"
export * from "./ContractProfileTemplateTab.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "510f8b9a",
  null
  
)

export default component.exports